import defaultMetrics from '@/organisms/plans/utils/defaultMetrics';
import ActionType from '@/shared/enums/ActionType';
import EntityType from '@/shared/enums/EntityType';
import entityLabel from '@/shared/utils/entityLabel';
import defaultMetricGroup from '@pkg/entities/snapshots/utils/defaultMetricGroup';
import Config from '@/lib/config';

export default function addedActivities({
  actionMap,
  activity,
  comparisonScenario,
  scenario,
}) {
  const role =
    activity.owner_type === EntityType.ROLE
      ? scenario.relationships.get(EntityType.ROLE)?.get(activity.owner_uuid)
      : null;
  const group = role
    ? scenario?.relationships.get(EntityType.GROUP)?.get(role.group_uuid)
    : scenario?.relationships.get(EntityType.GROUP)?.get(activity.owner_uuid);

  const activityBudget = activity.__metrics?.self.visible.budget || 0;
  const activityCost = activity.__metrics?.self.visible.cost || 0;

  const metrics = {
    hours: activity.hours,
    budget: activityBudget,
    activityBudget: activityBudget,
    allocatedFTE: activity.__metrics?.self.visible.allocatedFTE || 0,
    cost: activityCost,
  };

  const existingAction = actionMap?.get(ActionType.ADD_ACTIVITIES);

  const action = existingAction ?? {
    entity: EntityType.ACTIVITY,
    impact: { ...defaultMetricGroup(), activityBudget: 0 },
    metrics: defaultMetrics({ comparisonScenario }),
    type: ActionType.ADD_ACTIVITIES,
    [EntityType.ROLE]: new Set(),
    [EntityType.GROUP]: new Set(),
    [EntityType.ACTIVITY]: new Map(),
  };

  if (role) {
    action[EntityType.ROLE].add(role.uuid);
  }
  if (group) {
    action[EntityType.GROUP].add(group.uuid);
  }

  // Impact changes.
  const factor = role ? metrics.hours / Config.FTE_HOURS_PER_WEEK : 0;
  const fteImpact = role ? role.fte * factor : 0;

  action.impact.activities += 1;
  action.impact.hours += metrics.hours;
  action.impact.roles = action[EntityType.ROLE].size;
  action.impact.actionActivity += metrics.activityBudget;
  action.impact.budget += metrics.budget;
  action.impact.cost += metrics.cost;
  action.impact.fte += fteImpact;
  action.impact.allocatedFTE += metrics.allocatedFTE;

  action.metrics[1].activities += 1;
  action.metrics[1].hours += metrics.hours;
  action.metrics[1].activityBudget += metrics.activityBudget;
  action.metrics[1].budget += metrics.budget;
  action.metrics[1].cost += metrics.cost;
  action.metrics[1].allocatedFTE += metrics.allocatedFTE;

  // Aggregate the individual activity action metrics.
  const actionActivity = action[EntityType.ACTIVITY].get(activity.uuid) ?? {
    impact: defaultMetricGroup(),
    metrics: defaultMetrics({ action, activity, comparisonScenario }),
  };
  actionActivity.metrics[1].activities += 1;
  actionActivity.metrics[1].hours += metrics.hours;
  actionActivity.metrics[1].budget += metrics.budget;
  actionActivity.metrics[1].activityBudget += metrics.activityBudget;
  actionActivity.metrics[1].cost += metrics.cost;
  actionActivity.metrics[1].allocatedFTE += metrics.allocatedFTE;
  action[EntityType.ACTIVITY].set(activity.uuid, actionActivity);

  // Individual activity impact changes.
  actionActivity.impact.activities = 1;
  actionActivity.impact.hours = metrics.hours;
  actionActivity.impact.roles = 1;
  actionActivity.impact.budget += metrics.budget;
  actionActivity.impact.activityBudget += metrics.activityBudget;
  actionActivity.impact.cost += metrics.cost;
  actionActivity.impact.allocatedFTE += metrics.allocatedFTE;
  actionActivity.impact.fte += fteImpact;

  const activityCount = action[EntityType.ACTIVITY].size;
  const roleCount = action[EntityType.ROLE].size;

  const roleLabel = entityLabel(EntityType.ROLE, roleCount !== 1);
  const activityLabel = entityLabel(EntityType.ACTIVITY, activityCount !== 1);
  const verb = activityCount === 1 ? 'was' : 'were';
  const adverb = roleCount === 1 ? 'to' : 'across';

  action.title = `${activityCount} ${activityLabel} ${verb} added ${adverb} ${roleCount} ${roleLabel}`;

  return action;
}
